import React, { useEffect } from 'react';
import { Dropdown, Image, type MenuProps } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import path from 'routes/Path';
import { icons } from 'utils/constants/icons';
import { getSignoutUri } from 'utils/constants/getSignoutUri';
import { useUser } from 'contexts/UserProvider';
import { DefaultAvatar } from 'assets/images';

const { LogoutOutlined, UserOutlined } = icons;

const Avatar = () => {
  // const navigate = useNavigate();
  const { user, signOut } = useUser();

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: <Link to={`${path.PROFILE}`}>Tài khoản</Link>,
      icon: <UserOutlined />,
    },
    {
      key: '2',
      label: <a onClick={signOut}>Đăng xuất</a>,
      icon: <LogoutOutlined />,
    },
  ];
  useEffect(() => {
    // console.log(user);
  }, [user]);
  return (
    <Dropdown
      className="cursor-pointer"
      menu={{ items }}
      placement="bottomLeft"
      arrow
      trigger={['click']}
    >
      <div className="flex items-center">
        {/* <Image
          preview={false}
          src={user?.avatar || DefaultAvatar}
          width={40}
          height={40}
          style={{ borderRadius: '50%', objectFit: 'fill' }}
        ></Image> */}
        <div className="text-main font-bold ml-2">{user?.fullName}</div>
      </div>
    </Dropdown>
  );
};

export default Avatar;
